import { render } from "./App.vue?vue&type=template&id=70a349bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=70a349bc&lang=css"

import exportComponent from "/home/bammer/vue/doit-vue/vue-todo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__